<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    @if (event) {
      <ion-title>
        {{event.title}}
        <p class="subtitle">Sessions</p>
      </ion-title>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (sessions && sessions.length != 0) {
    <ion-list>
      @for (session of sessions; track session) {
        <ion-item detail="true" button="true" lines="full" (click)="presentSelectSessionTicketTypeModal(event, session)">
          <ion-label>
            <h3>
              @if (session.title) {
                <span>{{session.title}}</span>
              }
              @if (!session.title) {
                <span>{{event.title}}</span>
              }
            </h3>
            <ion-grid class="ion-no-padding">
              @if (session.start_date || session.end_date || session.venue) {
                <ion-row>
                  @if (session.start_date) {
                    <ion-col class="ion-text-nowrap" size="auto">
                      <h5>Start date</h5>
                      <p class="prominent">{{moment.utc(session.start_date).tz(session.timezone.code).format("D MMM YYYY, HH:mm")}}</p>
                    </ion-col>
                  }
                  @if (session.end_date) {
                    <ion-col class="ion-text-nowrap" size="auto">
                      <h5>End date</h5>
                      <p class="prominent">{{moment.utc(session.end_date).tz(session.timezone.code).format("D MMM YYYY, HH:mm")}}</p>
                    </ion-col>
                  }
                  @if (session.venue && (session.venue.name || session.venue.address?.locality)) {
                    <ion-col size="auto">
                      <h5>Venue</h5>
                      <p class="prominent">
                        @if (session.venue.name) {
                          <span>{{session.venue.name}}</span>
                        }
                        @if (!session.venue.name) {
                          <span>{{session.venue.address.locality}}</span>
                        }
                      </p>
                    </ion-col>
                  }
                </ion-row>
              }
              <ion-row>
                <ion-col size="auto">
                  <h5>Tickets sold</h5>
                  <p class="prominent">{{session.tickets_sold_count}}</p>
                </ion-col>
                @if (session.tickets_left_count) {
                  <ion-col size="auto">
                    <h5>Tickets left</h5>
                    <p class="prominent">
                      @if (session.tickets_left_count > session.low_ticket_threshold) {
                        <span class="success">{{session.tickets_left_count}}</span>
                      }
                      @if (session.tickets_left_count <= session.low_ticket_threshold && session.tickets_left_count > 0) {
                        <span class="warning"></span>
                      }
                      @if (session.tickets_left_count <= 0) {
                        <span class="danger">{{session.tickets_left_count}}</span>
                      }
                    </p>
                  </ion-col>
                }
              </ion-row>
            </ion-grid>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  }

  @if (sessions && sessions.length == 0) {
    <ion-grid class="nothing-found">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col>
          <p>
            <fa-icon [icon]="['fal', 'calendar-day']" size="6x"></fa-icon>
            <span>No sessions found</span>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>